import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";

import { CartProvider } from "./store/cart";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Loader from "./components/Loader";
import CustomCursor from "./components/CustomCursor";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import OrderLookup from "./pages/OrderLookup";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Manifesto from "./pages/Manifesto";
import Legal from "./pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Loader />
        <CustomCursor />
        <div className="noise min-h-screen bg-ink text-bone flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/order-lookup" element={<OrderLookup />} />
              <Route path="/manifesto" element={<Manifesto />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                color: "#F3F3F1",
                border: "1px solid rgba(243,243,241,0.2)",
                borderRadius: 0,
                fontFamily: "Space Mono, monospace",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                fontSize: "12px",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
